import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`

export const InputContainer = styled.div<{ width?: string }>`
  display: flex;
  height: 100%;
  gap: 0.3rem;
  flex-direction: column;
  width: ${(props) => (props.width ? props.width : '100%')};

  > span {
    font-size: 14px;
    color: #494949;
  }

  > textarea {
    resize: none;
    min-height: 10rem;
    padding: 0.5rem;
    border: 1px solid #cecece;
    border-radius: 6px;
  }
`

export const Map = styled.div<{ background: string; border: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: ${(props) => props.background};
  border: ${(props) => (props.border ? '2px solid #BB0000' : '1px solid #cecece')};
  border-radius: 6px;
  cursor: pointer;
  min-height: 80px;
  min-width: 120px;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > span {
    font-size: 12px;
    color: ${(props) => (props.border ? '#fff' : '#BB0000')};
    font-weight: 500;
  }
`
